import { useState, useRef } from 'react';

interface UseBookCoverVideoReturn {
  videoRef: React.RefObject<HTMLVideoElement | null>;
  hasVideo: boolean | null;
  showVideo: boolean;
  handleMouseEnter: () => void;
  handleMouseLeave: () => void;
  coverVideoPath: string;
}

export const useBookCoverVideo = (coverAnimationUrl?: string | null): UseBookCoverVideoReturn => {
  const videoRef = useRef<HTMLVideoElement>(null);
  const [hasVideo, setHasVideo] = useState<boolean | null>(null);
  const [showVideo, setShowVideo] = useState(false);

  const coverVideoPath = coverAnimationUrl || '';

  const handleMouseEnter = () => {
    if (videoRef.current) {
      if (!coverVideoPath) {
        setHasVideo(false);
        setShowVideo(false);
        return;
      }

      // Show video immediately
      setShowVideo(true);

      // Try to play the video
      videoRef.current.play().catch(error => {
        console.log('Video play failed:', error);
        // If play fails, video might not exist - hide it
        setHasVideo(false);
        setShowVideo(false);
      });

      // Mark that we have video on successful loadedmetadata
      if (hasVideo === null && videoRef.current) {
        videoRef.current.addEventListener('loadedmetadata', () => {
          setHasVideo(true);
        }, { once: true });

        videoRef.current.addEventListener('error', () => {
          setHasVideo(false);
          setShowVideo(false);
        }, { once: true });
      }
    }
  };

  const handleMouseLeave = () => {
    if (videoRef.current) {
      videoRef.current.pause();
      videoRef.current.currentTime = 0;
      setShowVideo(false);
    }
  };

  return {
    videoRef,
    hasVideo,
    showVideo,
    handleMouseEnter,
    handleMouseLeave,
    coverVideoPath,
  };
};
